import GeneralReducer from './generalReducer'
import JiraReducer from './jiraReducer'
import RulesReducer from './rulesreducer'
import QuestionsReducer from './questionsreducer'
import ExampleMapReducer from './exampleMapReducer'

import { combineReducers } from 'redux'

export const RootReducer = combineReducers({
  general: GeneralReducer,
  jira: JiraReducer,
  exampleMap: ExampleMapReducer,
  rules: RulesReducer,
  questions: QuestionsReducer
})

export default RootReducer
